import React from "react";

import { noop } from "lodash";

import { FeedbackFilter } from "./utils";

export interface FeedbackContext {
	filter: FeedbackFilter;
	priority: number;
	everythingElse: number;
	setFilter: (filter: FeedbackFilter) => void;
	setPriority: (count: number) => void;
	setEverythingElse: (count: number) => void;
}

const FeedbackContext = React.createContext<FeedbackContext>({
	filter: FeedbackFilter.INBOX,
	priority: 0,
	everythingElse: 0,
	setFilter: noop,
	setPriority: noop,
	setEverythingElse: noop,
});
FeedbackContext.displayName = "FeedbackContext";

export default FeedbackContext;
